if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        // this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.querySelector('[data-spinner]').classList.remove('!hidden')
        // this.submitButton.querySelector('span').classList.add('hidden')

        window.addLineItems(
          (cart) => {
            this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('[data-spinner]').classList.add('!hidden')
          },
          [
            {
              id: parseInt(this.form.querySelector('[name="id"]').value),
              quantity: this.form.querySelector('[name="quantity"]')
                ? this.form.querySelector('[name="quantity"]').value
                : 1,
            },
          ],
          true,
        )
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}
